export default "mutation processaLatitudineCerved($params: ProcessaLatitudineParams!) {\n        processaLatitudineCerved(params: $params)\n}";